import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-banner-message',
  templateUrl: './banner-message.component.html',
  styleUrls: ['./banner-message.component.scss']
})
export class BannerMessageComponent {
  @Input()
  majorMessage = ''
  @Input()
  success!: boolean
  @Input()
  minorMessage=''
  showPopup = true
}
